export function DossierPreview(): JSX.Element {
  return (
    <div className="appearance-preview preview-dossier">
      <i />
      <div>
        <b />
        <section>
          <span />
          <span />
        </section>
        <span />
      </div>
    </div>
  );
}
